(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/progress-bar.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/progress-bar.js');
"use strict";

const _svs$components$tipse = svs.components.tipsen.betslipComponents,
  Betslip = _svs$components$tipse.Betslip,
  useBetslipContext = _svs$components$tipse.useBetslipContext;
const ProgressBar = svs.components.lbUi.progressBar.ProgressBar;
const className = 'pg_betslip__progress_bar';
const BetslipProgressBar = () => {
  const context = useBetslipContext();
  const couponEventsStarted = context.couponEventsStarted,
    couponEventCount = context.couponEventCount;
  return React.createElement("div", {
    className: "pg_betslip__progress"
  }, React.createElement(ProgressBar, {
    className: className,
    currValue: couponEventsStarted,
    maxValue: couponEventCount,
    minValue: 0
  }), React.createElement(Betslip.ProgressDisplay, {
    eventsStarted: couponEventsStarted,
    maxEvents: couponEventCount
  }));
};
Betslip.ProgressBar = BetslipProgressBar;

 })(window);